import { CalendarIcon } from "@heroicons/react/24/outline";

const DateField = ({ value, onChange }) => {
    return (
        <div className="relative w-full">
            <span className="absolute -translate-y-1/2 start-3 top-1/2">
                <CalendarIcon className="w-5 h-5 text-text-muted-light dark:text-text-muted-dark" />
            </span>

            <input
                type="date"
                value={value}
                onChange={onChange}
                className="w-full px-4 py-3 text-black border date-input dark:text-white bg-bg-light-primary dark:bg-bg-dark-primary border-border-light dark:border-border-dark rounded-xl focus:outline-none focus:ring focus:ring-primary-light dark:focus:ring-primary"
            />
        </div>
    );
};

export default DateField;
